module.exports = __webpack_public_path__ + "img/5-4.de6708f5.svg";